import React, { useState, useEffect } from "react";
import { Table, Button, Badge, Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../../../components/admin/sidebar/adminSidebar";
import axiosInstance from "../../../api/axios";

export default function ApprovalRequestList() {
  const [approvalRequests, setApprovalRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  // 사용자의 역할을 받아오는 함수 (API 연동 가능)
  const getUserRole = () => {
    const user = JSON.parse(sessionStorage.getItem("user")); // "user"라는 key로 저장된 데이터 가져오기
    return user ? user.position : null; // user가 존재하면 position 반환, 없으면 null
  };

  const userRole = getUserRole();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get("/api/approval-request/list");
        const requestsData = Array.isArray(response.data)
          ? response.data
          : response.data.data; // 데이터 배열 추출

        // 역할별로 필터링
        let filteredRequests = [];
        if (userRole === "원장") {
          filteredRequests = requestsData.filter(
            (request) => request.status === "PENDING"
          );
        } else if (userRole === "이사장") {
          filteredRequests = requestsData.filter(
            (request) => request.status === "FIRST_APPROVED"
          );
        }

        setApprovalRequests(filteredRequests || []);
      } catch (error) {
        console.error("Error fetching approval requests:", error);
        setApprovalRequests([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString("ko-KR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "PENDING":
        return <Badge bg="warning">요청</Badge>;
      case "APPROVED":
        return <Badge bg="success">승인</Badge>;
      case "REJECTED":
        return <Badge bg="danger">반려</Badge>;
      default:
        return <Badge bg="secondary">알 수 없음</Badge>;
    }
  };

  const getCategory = (category) => {
    switch (category) {
      case "EXPENDITURE":
        return "지출";
      case "EMPLOYMENT":
        return "재직증명서";
      case "OTHER":
        return "기타";
      default:
        return "알 수 없음";
    }
  };

  const handleStatusChange = async (approvalRequestId, status) => {
    try {
      await axiosInstance.patch(
        `/api/approval-request/status/${approvalRequestId}`,
        { status }
      );
      setApprovalRequests((prevRequests) =>
        prevRequests.filter(
          (request) => request.approvalRequestId !== approvalRequestId
        )
      );
      alert(
        `결재 요청이 ${status === "APPROVED" ? "승인" : "반려"}되었습니다.`
      );
    } catch (error) {
      console.error(
        `Error updating approval request ${approvalRequestId}:`,
        error
      );
      alert("결재 요청 상태를 업데이트하는 중 오류가 발생했습니다.");
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRequests = approvalRequests.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <AdminSidebar>
      <div className="approval-requests-page my-5">
        <h2 className="text-center mb-4">결재 요청 목록</h2>

        {loading ? (
          <p className="text-center">로딩 중...</p>
        ) : (
          <>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>제목</th>
                  <th>구분</th>
                  <th>요청자</th>
                  <th>상태</th>
                  <th>요청일</th>
                  {/* <th>작업</th> */}
                </tr>
              </thead>
              <tbody>
                {currentRequests.map((request, index) => (
                  <tr
                    key={request.approvalRequestId}
                    onClick={() =>
                      navigate(
                        `/admin/approval-request/detail/${request.approvalRequestId}`
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{request.title}</td>
                    <td>{getCategory(request.category)}</td>
                    <td>{request.nameKor}</td>
                    <td>
                      <Badge bg="warning">요청</Badge>
                    </td>
                    <td>{formatDate(request.createdAt)}</td>
                    {/* <td>
                      <Button
                        variant="success"
                        size="sm"
                        className="me-2"
                        onClick={() =>
                          handleStatusChange(
                            request.approvalRequestId,
                            "APPROVED"
                          )
                        }
                      >
                        승인
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() =>
                          handleStatusChange(
                            request.approvalRequestId,
                            "REJECTED"
                          )
                        }
                      >
                        반려
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </Table>

            <Pagination className="justify-content-center mt-4">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />
              {Array.from(
                { length: Math.ceil(approvalRequests.length / itemsPerPage) },
                (_, i) => (
                  <Pagination.Item
                    key={i + 1}
                    active={i + 1 === currentPage}
                    onClick={() => handlePageChange(i + 1)}
                  >
                    {i + 1}
                  </Pagination.Item>
                )
              )}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={
                  currentPage ===
                  Math.ceil(approvalRequests.length / itemsPerPage)
                }
              />
              <Pagination.Last
                onClick={() =>
                  handlePageChange(
                    Math.ceil(approvalRequests.length / itemsPerPage)
                  )
                }
                disabled={
                  currentPage ===
                  Math.ceil(approvalRequests.length / itemsPerPage)
                }
              />
            </Pagination>
          </>
        )}
      </div>
    </AdminSidebar>
  );
}
